import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import cn from 'classnames';
import styles from './User.scss';

import Avatar from '../../common/Avatar/Avatar';
import Dropdown from '../../common/Dropdown/Dropdown';

import { withRouter } from 'react-router-dom';

import UserInfo from './UserInfo/UserInfo';
import { loadProfile } from 'actions/profile';

import { ROOT_URL } from 'constants/Config';

import iconUser from 'assets/images/icons/icon-user.svg';
import { withTranslation } from 'react-i18next';
import { gaEvent, trackGA } from 'services/ga';

class User extends Component {
  render() {
    const { className, withClient, avatarId, firstName, lastName, roleName, isBlocked, profile, t } = this.props;
    return (
      <div
        className={cn(styles.User, className)}
      >
        <Avatar
          className={cn(styles.Avatar, { [styles.WithClient]: withClient })}
          image={avatarId ? `${ROOT_URL}/image/get?id=${avatarId}&preset=profile_avatar` : iconUser}
        />
        <div className={cn(styles.UserDropdownWrap, { [styles.WithClient]: withClient })}>
          <Dropdown
            buttonStyle={styles.Dropdown}
            textStyle={styles.DropdownText}
            text={`${firstName || ''} ${lastName || ''}`}
            iconStyle={styles.DropdownIcon}
            rightShift
            onClick={() => trackGA(gaEvent.headerButtonsClick({
              eventLabel: 'profil',
              user_id: profile.id
            }))}
          >
            <UserInfo roleName={roleName} isBlocked={isBlocked} profile={profile} />
          </Dropdown>
          {withClient ? (
            <span className={styles.UserStatus}>
              {t('components.header.user.withClient2')}
            </span>
          ) : (null)}
        </div>
      </div>
    );
  }
}

const userSelector = createSelector(
  state => state.profile,
  state => state.privacy,
  (profile, privacy) => ({
    ...privacy,
    ...profile,
    profile
  })
);

export default User = withTranslation()(
  connect(
    userSelector,
    { loadProfile }
  )(
    withRouter(User)
  )
);



// WEBPACK FOOTER //
// ./src/components/Header/User/User.js